import { defineMessages } from 'react-intl';

const messages = defineMessages({
    pageTitle: {
        id:'pageTitleCollaboratorsPage',
        defaultMessage: 'LabXchange Collaborators',
        description: 'The title of the page.',
    },
    pageSubTitle: {
        id:'pageSubTitleCollaboratorsPage',
        defaultMessage: 'LabXchange convenes a community that believes in the transformative power of education.',
        description: 'The subtitle of the page.',
    },
    loadFailed: {
        id:'loadCollaboratorsPageFailed',
        defaultMessage: 'Collaborators page failed to load.',
        description: 'Message displayed when the background request on the collaborators page fails.',
    },
    sponsors: {
        id:'sponsors',
        defaultMessage: 'Sponsor',
        description: 'Text for the sponsor heading.',
    },
    sponsorsSub: {
        id:'sponsorsSub',
        defaultMessage: 'Our sponsor\'s commitment to excellence in science education makes LabXchange possible.',
        description: 'Text for the sponsor subheading.',
    },
    strategicAllies: {
        id:'strategicAllies',
        defaultMessage: 'Strategic Allies',
        description: 'Text for the strategic allies heading.',
    },
    strategicAlliesSub: {
        id:'strategicAlliesSub',
        defaultMessage: 'We join with mission-driven organizations to harness technology and mobilize networks.',
        description: 'Text for the strategic allies subheading.',
    },
    collaborators: {
        id:'collaborators',
        defaultMessage: 'Content collaborators',
        description: 'Text for the sponsor heading.',
    },
    collaboratorsSub: {
        id:'collaboratorsSub',
        defaultMessage: 'These organizations create the exceptional digital learning resources that you find on LabXchange.',
        description: 'Text for the sponsor subheading.',
    },
    communities: {
        id:'communities',
        defaultMessage: 'LabXchange communities',
        description: 'Text for the sponsor heading.',
    },
    communitiesSub: {
        id:'communitiesSub',
        defaultMessage: 'Educators in these universities, schools, and organizations are using LabXchange to improve the learning experience for their communities.',
        description: 'Text for the sponsor subheading.',
    },
    seeProfile: {
        id:'seeProfile',
        defaultMessage: 'See profile',
        description: 'Text for the link to the organization profile.',
    },
    viewWebsite: {
        id:'viewWebsite',
        defaultMessage: 'View website',
        description: 'Text for the link to the organization website.',
    },
    collaborateWithUs: {
        id:'collaborateWithUs',
        defaultMessage: 'Collaborate with us',
        description: 'Text for the mailto link.',
    },
    a2H: {
        id:'a2H',
        defaultMessage: 'A - H',
        description: 'Subsection title for communities from A to H.',
    },
    i2R: {
        id:'i2R',
        defaultMessage: 'I - R',
        description: 'Subsection title for communities from I to R.',
    },
    s2Z: {
        id:'s2Z',
        defaultMessage: 'S - Z',
        description: 'Subsection title for communities from S to Z.',
    },
});

export default messages;
